import React, { useEffect } from "react";
import { redirect, useNavigate, useParams } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import useEvaluationActions from "../../../api/hooks/rater/evaluation";
import {
  evaluateIndexState,
  evaluationQuestionsListState,
  evaluationRoomSnState,
  evaluateComboState,
  evaluationItemsState,
  evaluateArrayIndexSelector,
  evaluationListState,
  canEvaluateSelector,
} from "../../../recoil/rater/evaluation";
import QuestionNumberBox from "../../atoms/buttons/QuestionNumberBox";
import EvaluationQuestionsList from "../../modules/rater/EvaluationQuestionsList";
import RaterComment from "../../modules/rater/RaterComment";
import { SERVER_IP } from "../../../static/server";
import { examTrim } from "../../../api/examTrim";

const Evaluation = () => {
  const navigate = useNavigate();

  //시험실 번호 url 파라미터로 가져옴
  const { room_sn } = useParams();
  const evaluationActions = useEvaluationActions();
  const setEvaluationQuestionsList = useSetRecoilState(
    evaluationQuestionsListState
  );

  const evaluateArrayIndex = useRecoilValue(evaluateArrayIndexSelector);
  const canEvaluate = useRecoilValue(canEvaluateSelector);
  //시험실 번호 저장
  const [evaluationRoomSn, setEvaluationRoomSn] = useRecoilState(
    evaluationRoomSnState
  );

  //문항 번호
  const [evaluateIndex, setEvaluateIndex] = useRecoilState(evaluateIndexState);

  //콤보 번호
  const [evaluateCombo, setEvaluateCombo] = useRecoilState(evaluateComboState);

  //평가 문항 정보
  const [evaluationItems, setEvaluationItems] =
    useRecoilState(evaluationItemsState);

  const setEvaluationList = useSetRecoilState(evaluationListState);

  useEffect(() => {
    //시험실 번호 url 파라미터로 가져와서 저장함
    setEvaluationRoomSn(room_sn);

    //시험실 번호, 평가자 정보로 문항 등 조회
    // getEvaluationQuestionsList({
    //   room_sn,
    // });

    getEvaluationItems({
      room_sn,
    });
  }, [room_sn]);

  const getEvaluationItems = async (params) => {
    const res = await evaluationActions.getEvaluationItems(params);

    if (res.status === 400) {
      alert("평가 항목이 존재하지 않습니다.");
      return navigate("/rater/examroom");
    }

    setEvaluationItems(res.data);
    setEvaluationQuestionsList(res?.data?.raterText);
    setEvaluationList(
      res?.data?.question.map((q) => {
        return {
          question_sn: q.question_sn,
          ratingList: res.data.raterText.map((t) => {
            return { item_sn: t.item_sn };
          }),
        };
      })
    );

    setEvaluateCombo((old) => {
      return {
        ...old,
        total: res.data.question.length / evaluateIndex.total,
      };
    });
  };

  const evaluateNumberBox = (evaluateIndex) => {
    //평가 문항 번호 생성 로직
    const rows = [];

    for (let i = 1; i <= evaluateIndex.total; i++) {
      rows.push(
        <QuestionNumberBox
          key={i}
          index={i}
          active={i === evaluateIndex.current}
          onClick={() =>
            setEvaluateIndex((old) => {
              return {
                ...old,
                current: i,
              };
            })
          }
        />
      );
    }

    return rows;
  };

  return (
    <div className="rater-section">
      {evaluationItems.tester_sn && (
        <>
          <div className="white-section">
            <div className="gauge-box flex">
              <button
                type="button"
                className="evalation-btn unrated"
                onClick={() => {
                  navigate("/rater/examroom");
                }}
              >
                시험실 목록
              </button>
            </div>
            <div className="gauge-box flex">
              <div className="ing-gauge text-align-center">
                <p>
                  평가진행 ({evaluationItems?.inprogress?.done}/
                  {evaluationItems?.inprogress?.total})
                </p>
                <div className="slidecontainer">
                  <input
                    type="range"
                    min={0}
                    max={evaluationItems?.inprogress?.total || 0}
                    className="slider"
                    value={evaluationItems?.inprogress?.done || 0}
                    disabled
                  />
                </div>
              </div>
              <div>
                <button
                  //마지막 번호일때 버튼 잠금
                  disabled={!canEvaluate}
                  type="button"
                  className="next-btn"
                  //다음 버튼 누를시 + 1
                  onClick={async () => {
                    const res = await evaluationActions.evaluateUserAnswer();
                    if (res.status === 200) {
                      getEvaluationItems({
                        room_sn,
                      });
                      setEvaluateIndex((old) => {
                        return {
                          ...old,
                          current: 1,
                        };
                      });

                      // if (evaluateCombo.current < evaluateCombo.total) {
                      //   setEvaluateIndex((old) => {
                      //     return {
                      //       ...old,
                      //       current: 1,
                      //     };
                      //   });
                      //   setEvaluateCombo((old) => {
                      //     return {
                      //       ...old,
                      //       current: old.current + 1,
                      //     };
                      //   });
                      // } else {
                      //   alert("평가가 왼료되었습니다.");
                      //   navigate("/rater/examroom");
                      // }
                    }
                  }}
                >
                  다음
                </button>
              </div>
            </div>
            <div className="border-line"></div>
            <div className="question-number-box">
              {evaluateNumberBox(evaluateIndex)}
            </div>
            <div>
              {/* <div>
              {evaluationItems[evaluateArrayIndex].media_type === 0 && (
                <audio
                  controls
                  autoPlay
                  src={`${hostURL}/${evaluationItems[evaluateArrayIndex]?.url}`}
                />
              )}
            </div> */}

              {evaluationItems?.question && evaluationItems?.answerList && (
                <>
                  {/* <p>{evaluationItems?.question[evaluateArrayIndex].text}</p> */}
                  <p style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
                    {examTrim(
                      evaluationItems?.question[evaluateArrayIndex].text
                    )}
                  </p>
                  <div className="video-box">
                    <video
                      width="100%"
                      controls
                      autoPlay
                      src={`${SERVER_IP}/${evaluationItems.answerList[evaluateArrayIndex]}`}
                    />
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="white-section">
            <div className="guide-comment text-align-center">
              <p> 평가 후 '평가완료'를 클릭해야 완료됩니다.</p>
            </div>
            <div>
              <EvaluationQuestionsList />
              <div className="border-line"></div>
            </div>
            <RaterComment />
          </div>
        </>
      )}
    </div>
  );
};

export default Evaluation;
